var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQwikLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "274px",
    viewBox: "0 0 256 274",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Qwik") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "22.3466703%",
    y1: "49.544504%",
    x2: "77.5167035%",
    y2: "50.3881932%",
    id: "qwikLinearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4340C4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4642C8",
    offset: "12%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#594EE4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "38.8735478%",
    y1: "49.8446404%",
    x2: "60.8793852%",
    y2: "50.3848308%",
    id: "qwikLinearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4340C4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#534ADB",
    offset: "74%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#594EE4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.00369266634%",
    y1: "49.529363%",
    x2: "100.122955%",
    y2: "50.2226751%",
    id: "qwikLinearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4340C4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4340C4",
    offset: "23%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F48D5",
    offset: "60%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#594EE4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "35.3999594%",
    y1: "49.4594565%",
    x2: "64.8953491%",
    y2: "50.0846115%",
    id: "qwikLinearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0080FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B9FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.243451404%",
    y1: "49.3660536%",
    x2: "100.41142%",
    y2: "50.4669186%",
    id: "qwikLinearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0080FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008BFF",
    offset: "17%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7FF",
    offset: "47%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B9FF",
    offset: "63%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B9FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.124634779%",
    y1: "49.6273118%",
    x2: "100.224751%",
    y2: "50.1006469%",
    id: "qwikLinearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B9FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0080FF",
    offset: "30%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D67F1",
    offset: "60%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D55E8",
    offset: "86%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#594EE4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.55652121%",
    y1: "50.1842666%",
    x2: "99.3543954%",
    y2: "51.297514%",
    id: "qwikLinearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4340C4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4642C8",
    offset: "12%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#594EE4",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#qwikLinearGradient-1)",
    points: "175.050684 236.85937 200.213062 221.788423 249.510531 134.858942 173.224125 223.955775"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.336691,80.4078804 L237.411112,71.0078458 L235.479128,67.3449214 L235.278084,67.541062 L209.461087,20.5261781 C202.983546,8.64986934 190.631597,1.23085399 177.009637,1.07394157 L151.935523,1.27988912 L188.150419,114.801121 L164.191854,138.132037 L173.116248,224.377478 L246.884699,140.35578 C256.890318,128.768779 258.854175,112.266005 251.805375,98.7102431 L242.339143,80.4078804 L242.336691,80.4078804 Z",
    fill: "url(#qwikLinearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.112856,72.2557898 L157.93252,1.3485383 L83.4113789,0.00252394874 C70.1645382,-0.149484958 57.8297509,6.57323154 50.879021,17.8709258 L7.00974088,101.74797 L41.4520171,68.4138873 L84.7010028,8.35565856 L182.594739,120.508811 L200.89465,101.882816 C209.291916,93.7405326 206.43562,82.325154 201.115308,72.2582416 L201.112856,72.2557898 Z",
    fill: "url(#qwikLinearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7835758,95.2606217 L84.5220246,8.79452298 L11.3738676,96.8248424 C-0.953564436,108.759993 -3.52300531,127.48651 4.95516888,142.314734 L47.9344614,217.041822 C54.4880067,228.506236 66.6903991,235.618781 79.9593056,235.77079 L122.904274,236.261142 L71.4590656,119.606564 L97.7835758,95.2606217 Z",
    fill: "url(#qwikLinearGradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.226577,223.899385 L71.3806094,119.023046 L58.1852556,131.612816 C47.3730092,141.861159 47.0787984,158.944998 57.4570839,169.534135 L101.4465,235.917896 L172.096317,236.825046 L173.224125,223.899385 L173.226577,223.899385 Z",
    fill: "url(#qwikLinearGradient-5)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#qwikLinearGradient-6)",
    points: "101.583799 235.903185 173.876293 224.303925 221.58012 273.768113"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.111344,224.482903 L200.279259,221.025926 L224.375122,270.941238 C225.434281,273.000714 222.656441,274.917987 221.001505,273.243438 L173.111344,224.482903 Z",
    fill: "url(#qwikLinearGradient-7)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "182.70752 120.057688 84.6813888 8.60083421 97.1828955 94.5594193 71.1599513 118.780322 172.932366 224.151916 165.336824 138.247269 182.70752 120.055236"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQwikLogo);
export default __webpack_public_path__ + "static/media/qwik-logo.53e11f30edacebae4efb4ac8cc6e0c65.svg";
export { ForwardRef as ReactComponent };